import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from './data.service';
import {Guest} from './module-page/module-page.component';
import { SocialUser } from 'ng4-social-login';

declare var ga: any;
declare var $: any;
declare function checkOnline(): boolean;
declare function CheckAPI(): any;
export let isOnline: boolean;
declare var iMissYou: any;
declare var fbq:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  currentUrl: string = "";
  loading: boolean = false;
  lock: boolean = false;
  guest:Guest=null;
  userId:number=-1;
  userTypeId:number=-1;
  public user: SocialUser;
  userName:string="";
  isUse: boolean = false;

  constructor(private router: Router, private service: DataService) {

    $.iMissYou({
      title: "Missing your attention",
      favicon: {
        enabled: true,
        src: 'assets/img/Default Favicon.png'
      }
    });

    $(window).bind('orientationchange', function (e) {
      switch (window.orientation) {
        case 0:
          $('.content').css('display', 'block');
          $('.isLandscape').css('display', 'none');
          // The device is in portrait mode now
          break;

        case 180:
          $('.content').css('display', 'block');
          $('.isLandscape').css('display', 'none');
          // The device is in portrait mode now
          break;

        case 90:
          // The device is in landscape now
          var mozFullScreen = $('#videoparent > iframe')['context']['mozFullScreen'];
          var webkitFullScreen = $('#videoparent > iframe')['context']['webkitIsFullScreen'];
          if (mozFullScreen == true || webkitFullScreen == true) {
            $('.content').css('display', 'block');
            $('.isLandscape').css('display', 'none');
          }

          if (mozFullScreen == false || webkitFullScreen == false) {
            $('.content').css('display', 'none');
            $('.isLandscape').css('display', 'block');
          }
          break;

        case -90:
          // The device is in landscape now
          var mozFullScreen = $('#videoparent > iframe')['context']['mozFullScreen'];
          var webkitFullScreen = $('#videoparent > iframe')['context']['webkitIsFullScreen'];
          if (mozFullScreen == true || webkitFullScreen == true) {
            $('.content').css('display', 'block');
            $('.isLandscape').css('display', 'none');
          }

          if (mozFullScreen == false || webkitFullScreen == false) {
            $('.content').css('display', 'none');
            $('.isLandscape').css('display', 'block');
          }
          break;
      }
    });

    setTimeout(() => {
      this.loading = false;
      console.log("APP MODULE");
      window.dispatchEvent(new Event('resize'));
    }, 5500)

    setInterval(() => {
      isOnline = checkOnline();
      if (!isOnline) {
        this.router.navigate(['/offline']);
      }
    }, 5000);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        sessionStorage.setItem('currentUrl', this.currentUrl);
        if(this.currentUrl == "/") {
          this.isUse = false;
        } else {
          this.isUse = true;
        }
        this.service.storageSub.next('change');
        $('#baseCode').remove();
        $('#noScript').remove();
        ga('set', 'page', "https://stratgist.com/landingpage" + event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });

  }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/app.component.ts